/**
 * Commit a discrete choice — select, combobox, enum picker, chip multi-select,
 * date picker, switch, attachment list. For these inputs choosing IS committing:
 * there is no "still editing" state, and many never fire a DOM blur at all.
 * Marking the field blurred is what makes its error visible immediately.
 *
 * Free-typing inputs must NOT use this — call `field.handleChange(value)` and
 * let the real blur commit them, or the user gets an error mid-word.
 *
 * The parameter is structural on purpose: `AnyFieldApi` is a class (nominal),
 * which rejects narrowed structural handles like the webapp's `FieldOf<TValue>`.
 */
export function commitFieldValue<TValue>(
  field: { handleChange: (value: TValue) => void; handleBlur: () => void },
  value: TValue,
): void {
  field.handleChange(value);
  field.handleBlur();
}
